import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Card, CardContent } from '@/components/ui/card';
import { FileText, AlertCircle, CheckCircle2 } from 'lucide-react';

const PassportRequirements = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <button
          onClick={() => navigate('/knowledge-base/documentation')}
          className="text-primary hover:text-primary/80 transition-colors mb-8 flex items-center"
        >
          ← Back to Documentation
        </button>

        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-4">
            Passport and ID Requirements
          </h1>
          <p className="text-muted-foreground">
            Detailed guide on passport and identification requirements for your Polish residence permit application.
          </p>
        </div>

        <div className="space-y-8">
          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4">Passport Requirements</h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <CheckCircle2 className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  Valid for at least 6 months beyond your planned stay
                </li>
                <li className="flex items-start">
                  <CheckCircle2 className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  At least two blank visa pages
                </li>
                <li className="flex items-start">
                  <CheckCircle2 className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  Good physical condition without damage
                </li>
                <li className="flex items-start">
                  <CheckCircle2 className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  Machine-readable zone (MRZ) must be clearly visible
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4">Required Copies</h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <FileText className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  Full copy of passport (all pages with stamps/visas)
                </li>
                <li className="flex items-start">
                  <FileText className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  Certified translation of relevant pages
                </li>
                <li className="flex items-start">
                  <FileText className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  Additional ID documents if applicable
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <AlertCircle className="h-5 w-5 text-primary mr-2" />
                Common Issues to Avoid
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Expired or nearly expired passports
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Missing or unclear passport pages
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Poor quality copies of documents
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Uncertified translations
                </li>
              </ul>
            </CardContent>
          </Card>

          <div className="bg-accent p-6 rounded-lg border border-border">
            <h2 className="text-xl font-semibold text-foreground mb-2">Need Help with Document Preparation?</h2>
            <p className="text-muted-foreground mb-4">
              Our team can review your documents and ensure they meet all requirements before submission.
            </p>
            <button 
              onClick={() => navigate('/contact')}
              className="bg-primary text-primary-foreground px-6 py-2 rounded-lg hover:bg-primary/90 transition-colors"
            >
              Get Document Review
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PassportRequirements; 